import { LangKey, useTranslation } from "@vixi/localization";
import { ComponentProps, FC, ReactNode } from "react";
import { Img } from "@vixi/ui";

// Assets
import fox from "@assets/fox.png";
import paper from "@assets/paper.svg";

const KnowledgeSourceHeaderRoot = (props: ComponentProps<"div">) => (
  <div className="min-h-content bg-paper h-47.5 w-full rounded py-5 ps-11.25 pe-12.5" {...props} />
);

interface KnowledgeSourceHeaderProps {
  title: LangKey;
  subtitle: LangKey;
  sourceIcon?: ReactNode;
}

const KnowledgeSourceHeader: FC<KnowledgeSourceHeaderProps> = ({ title, subtitle, sourceIcon }) => {
  const { t } = useTranslation();

  return (
    <KnowledgeSourceHeaderRoot>
      <div className="flex items-center justify-between p-0">
        <div className="mb-5">
          <h2 className="ar:font-bold font-semibold">{t(title)}</h2>
          <h5 className="fs-17 text-foreground-secondary ar:font-medium mt-6.5 font-semibold">
            {t(subtitle)}
          </h5>
        </div>

        <div className="flex min-w-0 items-center">
          <Img src={paper} className="w-15.5 sm:mx-1.25 lg:mx-3.75 lg:w-23.25" />
          <Img src={fox} width={118} className="sm:-ms-2.5 sm:me-1.5 lg:ms-7.5 lg:me-6" />
          {sourceIcon}
        </div>
      </div>
    </KnowledgeSourceHeaderRoot>
  );
};

export default KnowledgeSourceHeader;
